/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolFormatPaintIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-format-paint"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M11 22.8Q9.93 22.8 9.15 22.02Q8.38 21.25 8.38 20.18L8.38 16.77L5.83 16.77Q4.75 16.77 3.98 16.01Q3.2 15.25 3.2 14.15L3.2 7.13Q3.2 5.1 4.63 3.65Q6.05 2.2 8.07 2.2L19.48 2.2Q20.02 2.2 20.41 2.59Q20.8 2.98 20.8 3.52L20.8 14.15Q20.8 15.25 20.04 16.01Q19.27 16.77 18.18 16.77L15.63 16.77L15.63 20.18Q15.63 21.25 14.85 22.02Q14.07 22.8 13 22.8ZM5.83 9.68L18.18 9.68L18.18 4.83L17.23 4.83L17.23 7.22Q17.23 7.78 16.85 8.15Q16.48 8.53 15.93 8.53Q15.38 8.53 14.99 8.14Q14.6 7.75 14.6 7.2L14.6 4.83L13.65 4.83L13.65 5.45Q13.65 6 13.28 6.38Q12.9 6.75 12.35 6.75Q11.8 6.75 11.41 6.36Q11.03 5.97 11.03 5.42L11.03 4.83L8.07 4.83Q7.13 4.83 6.47 5.5Q5.83 6.17 5.83 7.13Z" fill={color} />
    </svg>
  );
}
